import { WithStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import * as React from 'react';
import { UpwardTransition } from 'src/utils';

import { ITrainingProgress, TrainingProgressState } from '../actions/imstat';
import i18n from '../resources/i18n';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
		},
		headerName: {
			backgroundColor: grey[100],
		},
		notCompleted: {
			color: red[700],
			fontWeight: 'bold',
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(2),
		},
	});

interface ITrainingProgressProps {
	data: TrainingProgressState;
	onClose: React.ReactEventHandler<{}>;
}

/**
 * 進捗状況
 */
const TrainingProgress: React.FC<
	ITrainingProgressProps & WithStyles<typeof styles>
> = props => {
	let body: JSX.Element;
	switch (props.data) {
		case 'none':
			body = <></>;
			break;
		case 'loading':
			body = (
				<>
					<LinearProgress />
					<ProgressTable classes={props.classes} />
				</>
			);
			break;
		default:
			const tableData = props.data as ITrainingProgress;
			body = <ProgressTable {...tableData} classes={props.classes} />;
	}
	return (
		<Dialog
			fullScreen={false}
			open={props.data !== 'none'}
			onClose={props.onClose}
			TransitionComponent={UpwardTransition}
		>
			<AppBar className={props.classes.appBar}>
				<Toolbar>
					<IconButton
						color="inherit"
						onClick={props.onClose}
						aria-label="Close"
					>
						<CloseIcon />
					</IconButton>
					<Typography variant="h6" color="inherit">
						{i18n.t('TrainingProgress_0001')}
					</Typography>
				</Toolbar>
			</AppBar>
			{body}
		</Dialog>
	);
};

interface IProgressTableProps extends ITrainingProgress {
	classes: any;
}
const ProgressTable: React.FC<IProgressTableProps> = props => {
	const { classes } = props;
	const contentShow: boolean =
		props.scormFlg !== null && props.scormFlg === 0;
	const scormShow: boolean = props.scormFlg !== null && props.scormFlg === 1;

	// 学習項目
	const learningStatus =
		!props.reqScoIndex || props.reqScoIndex === 0
			? '-'
			: props.compScoIndex + '/' + props.reqScoIndex;
	// テキスト受講
	const textStatus =
		!props.reqTextIndex || props.reqTextIndex === 0
			? '-'
			: props.compTextIndex + '/' + props.reqTextIndex;
	// テスト
	const testStatus =
		!props.reqTestIndex || props.reqTestIndex === 0
			? '-'
			: props.compTestIndex + '/' + props.reqTestIndex;
	// アンケート
	const enqueteStatus =
		!props.reqEnquete || props.reqEnquete === 0
			? '-'
			: props.compEnquete + '/' + props.reqEnquete;
	// 課題提出
	const reportSubmitStatus =
		!props.reqReport || props.reqReport === 0
			? '-'
			: props.complSubmitReport + '/' + props.reqReport;
	// 課題承認
	const reportApprovalStatus =
		!props.reqReport || props.reqReport === 0
			? '-'
			: props.approvalSubmitReport + '/' + props.reqReport;

	return (
		<div className={classes.root}>
			<Paper>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell className={classes.headerName}>
								{i18n.t('TrainingProgress_0002')}
							</TableCell>
							<TableCell className={classes.headerName}>
								{i18n.t('TrainingProgress_0003')}
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{scormShow && (
							<TableRow>
								<TableCell>
									{i18n.t('TrainingProgress_0004')}
								</TableCell>
								<TableCell
									className={
										props.compScoIndex !== props.reqScoIndex
											? classes.notCompleted
											: ''
									}
								>
									{learningStatus}
								</TableCell>
							</TableRow>
						)}
						{contentShow && (
							<TableRow>
								<TableCell>
									{i18n.t('TrainingProgress_0005')}
								</TableCell>
								<TableCell
									className={
										props.compTextIndex !==
										props.reqTextIndex
											? classes.notCompleted
											: ''
									}
								>
									{textStatus}
								</TableCell>
							</TableRow>
						)}
						{contentShow && (
							<TableRow>
								<TableCell>
									{i18n.t('TrainingProgress_0009')}
								</TableCell>
								<TableCell
									className={
										props.compTestIndex !==
										props.reqTestIndex
											? classes.notCompleted
											: ''
									}
								>
									{testStatus}
								</TableCell>
							</TableRow>
						)}
						<TableRow>
							<TableCell>
								{i18n.t('TrainingProgress_0006')}
							</TableCell>
							<TableCell
								className={
									props.compEnquete !== props.reqEnquete
										? classes.notCompleted
										: ''
								}
							>
								{enqueteStatus}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell>
								{i18n.t('TrainingProgress_0007')}
							</TableCell>
							<TableCell
								className={
									props.complSubmitReport !== props.reqReport
										? classes.notCompleted
										: ''
								}
							>
								{reportSubmitStatus}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell>
								{i18n.t('TrainingProgress_0008')}
							</TableCell>
							<TableCell
								className={
									props.approvalSubmitReport !==
									props.reqReport
										? classes.notCompleted
										: ''
								}
							>
								{reportApprovalStatus}
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</Paper>
		</div>
	);
};

export default withStyles(styles)(TrainingProgress) as React.ComponentType<
	ITrainingProgressProps
>;



// WEBPACK FOOTER //
// ./src/components/TrainingProgress.tsx